export const skillsHeaderData = {
  title: "Our Expertise in Tools & Technologies",
  description: "At Build Web IT, we combine top tools and technologies with experience to deliver digital solutions that help your business succeed. Whether it’s creating stunning designs, building fast websites, or developing powerful apps, our team ensures every project is efficient, reliable, and tailored to your goals.",
}

export const skillsData = [
  {
    name: "Adobe Illustrator",
    icon: "/assets/skills/adobe_illustrator.svg",
    highlight: 2,
  },
  {
    name: "Adobe Photoshop",
    icon: "/assets/skills/adobe_photoshop.svg",
    highlight: 2,
  },
  {
    name: "Canva",
    icon: "/assets/skills/canva.svg",
    highlight: 3,
  },
  {
    name: "Express.js",
    icon: "/assets/skills/expressjs.svg",
    highlight: 1,
  },
  {
    name: "Figma",
    icon: "/assets/skills/figma.svg",
    highlight: 3,
  },
  {
    name: "Firebase",
    icon: "/assets/skills/firebase.svg",
    highlight: 3,
  },
  {
    name: "Git",
    icon: "/assets/skills/git.svg",
    highlight: 3,
  },
  {
    name: "GitHub",
    icon: "/assets/skills/github.svg",
    highlight: 3,
    left: 15,
  },
  {
    name: "GraphQL",
    icon: "/assets/skills/graphql.svg",
    highlight: 1,
  },
  {
    name: "JavaScript",
    icon: "/assets/skills/javascript.svg",
    highlight: 2,
  },
  {
    name: "JSON Web Tokens",
    icon: "/assets/skills/jsonwebtokens.svg",
    highlight: 2,
  },
  {
    name: "MongoDB",
    icon: "/assets/skills/mongodb.svg",
    highlight: 1,
  },
  {
    name: "MySQL",
    icon: "/assets/skills/mysql.svg",
    highlight: 1,
  },
  {
    name: "NestJS",
    icon: "/assets/skills/nestjs.svg",
    highlight: 1,
  },
  {
    name: "Next.js",
    icon: "/assets/skills/next.svg",
    highlight: 1,
  },
  {
    name: "Node.js",
    icon: "/assets/skills/nodejs.svg",
    highlight: 2,
  },
  {
    name: "React",
    icon: "/assets/skills/react.svg",
    highlight: 1,
  },
  {
    name: "Redis",
    icon: "/assets/skills/redis.svg",
    highlight: 2,
  },
  {
    name: "Redux",
    icon: "/assets/skills/redux.svg",
    highlight: 3,
  },
  {
    name: "Socket.io",
    icon: "/assets/skills/socket.svg",
    highlight: 2,
  },
  {
    name: "TypeScript",
    icon: "/assets/skills/typescript.svg",
    highlight: 1,
  },
  {
    name: "Prisma",
    icon: "/assets/skills/prisma.svg",
    highlight: 1,
  },
  {
    name: "PostgreSQL",
    icon: "/assets/skills/postgresql.svg",
    highlight: 2,
  },
];
